"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _FlexItem = _interopRequireDefault(require("../Layouts/FlexItem"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['type', 'theme'];
/**
 * Divider
 * @keywords Horizontal separator, Line
 */

var Divider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Divider, _React$Component);

  function Divider() {
    _classCallCheck(this, Divider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Divider).apply(this, arguments));
  }

  _createClass(Divider, [{
    key: "render",
    value: function render() {
      return this.props.children ? this.renderDividerWithContent() : this.renderDivider();
    }
    /**
     * Render a basic divider.
     * @returns {ReactDOM} Basic divider.
     */

  }, {
    key: "renderDivider",
    value: function renderDivider() {
      /* eslint-disable no-unused-vars */
      // Pass props like data-test down but don't pass children
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["className", "children"]);
      /* eslint-enable no-unused-vars */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-divider ").concat(_ThemeManager.default.getVar('classPrefix')))
      }, styleProps, props));
    }
    /**
     * Render the divider along with the content from the child element.
     * @returns {ReactDOM} Divider with content.
     */

  }, {
    key: "renderDividerWithContent",
    value: function renderDividerWithContent() {
      return _react.default.createElement(_FlexLayout.default, {
        alignItems: "center"
      }, this.renderDivider(), _react.default.createElement(_FlexItem.default, {
        flexShrink: "0"
      }, this.props.children), this.renderDivider());
    }
  }]);

  return Divider;
}(_react.default.Component);

exports.default = Divider;
Divider.defaultProps = {
  type: 'full-width',
  theme: 'light'
};
Divider.propTypes = {
  /**
   * Items (child nodes).
   */
  children: _propTypes.default.node,

  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   *
   * Set the type of the divider.
   */
  type: _propTypes.default.oneOf(['full-width', 'short']),

  /**
   *
   * Styling for light or dark backgrounds.
   */
  theme: _propTypes.default.oneOf(['light', 'dark'])
};